import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import templateImagesApi from '@/features/dashboard/templateImages/api/templateImagesApi.ts';
import { templateImagesApiQueryKeys } from '@/features/dashboard/templateImages/api/templateImagesApi.queryKeys.ts';

export default function useDeleteTemplateImage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (fileId: string) => templateImagesApi.remove(fileId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: templateImagesApiQueryKeys.all(),
      });
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas usuwania grafiki.',
      });
    },
  });
}
